import { useState } from "react";

const LOGO_URL = "https://customer-assets-eiarnc6j.emergentagent.net/job_umzug-markgraefler/artifacts/omy729i8_Unbenannt%20%281%29.jpeg";

export default function BrandMark({ testId, compact = false }) {
  const [logoFailed, setLogoFailed] = useState(false);

  return (
    <span
      className={`brand-mark ${compact ? "brand-mark-compact" : ""}`}
      data-testid={testId}
      aria-label="VanAkkeren Räumungsservice"
    >
      {logoFailed ? (
        <span className="brand-mark-fallback" aria-hidden="true">VA</span>
      ) : (
        <img
          className="brand-logo-image"
          src={LOGO_URL}
          alt="Wappen von VanAkkeren Räumungsservice"
          onError={() => setLogoFailed(true)}
        />
      )}
      <span className="brand-copy">
        <strong>VANAKKEREN</strong>
        <small>RÄUMUNGSSERVICE · MÜLLHEIM</small>
      </span>
    </span>
  );
}
